import { batchDepth, unbatchDepth, untrackDepth } from '../signal'
import { undispatchDepth } from '../undispatch'

export function isInAction(): boolean {
  return unbatchDepth === 0 && batchDepth > 0 && untrackDepth > 0
}

export function isInBatch(): boolean {
  return unbatchDepth === 0 && batchDepth > 0
}

export function isInUnbatch(): boolean {
  return unbatchDepth > 0
}

export function isInUndispatch(): boolean {
  return undispatchDepth > 0
}

export function isInUntrack(): boolean {
  return untrackDepth > 0
}
